import { useContext } from 'react';
import { AuthContext, type AuthContextValue, type AuthState } from './auth-context';
import type { SandboxSession } from '../lib/sandbox/session';

function useAuthCtx(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth* must be used inside <AuthProvider>');
  return ctx;
}

export function useAuthState(): AuthState {
  return useAuthCtx().state;
}

export function useAuthActions(): Pick<AuthContextValue, 'signUp' | 'signIn' | 'signOut'> {
  const { signUp, signIn, signOut } = useAuthCtx();
  return { signUp, signIn, signOut };
}

export function useSandboxSession(): SandboxSession {
  return useAuthCtx().session;
}
